import { action, observable } from 'mobx';

import messagingService from 'services/MessagingService/MessagingService';
import {
  GET_PEEK_STREAMING_INFO,
  GET_PEEK_STREAMING_INFO_ERROR,
  GET_PEEK_STREAMING_INFO_RESPONSE,
  ONLINE_FRIENDS_FAVORITES,
} from 'services/MessagingService/EventNames';


class PeekStore {
  @observable peekStreamingInfo = {};
  @observable openedPeekWindows = [];
  @observable requestedPeekWindows = [];
  @observable userType = '';

  constructor() {
    this.messagingService = messagingService();
    this.messagingService.on(ONLINE_FRIENDS_FAVORITES, this._handleFriendsFavorites);
    this.messagingService.on(GET_PEEK_STREAMING_INFO_RESPONSE, this._handlePeekStreamingInfo);
    this.messagingService.on(GET_PEEK_STREAMING_INFO_ERROR, this._handlePeekStreamingError);
  }

  destructor() {
    this.messagingService.off(ONLINE_FRIENDS_FAVORITES, this._handleFriendsFavorites);
    this.messagingService.off(GET_PEEK_STREAMING_INFO_RESPONSE, this._handlePeekStreamingInfo);
    this.messagingService.off(GET_PEEK_STREAMING_INFO_ERROR, this._handlePeekStreamingError);
  }

  @action _handleFriendsFavorites = ([friends, favorites]) => {
    if (window.location.pathname !== '/broadcast') {
      const usernames = [...friends.users, ...favorites.users]
        .sort(this._peekUsersComparator)
        .map((user) => user.username);
      this.openedPeekWindows = this.openedPeekWindows.filter((peek) => usernames.includes(peek.performerName));
    }
  };

  _peekUsersComparator = (a, b) => {
    if (a.isBroadcasting !== b.isBroadcasting) {
      return a.isBroadcasting ? -1 : 1;
    }

    return a.username > b.username ? 1 : -1;

  };

  @action requestPeekStream = (username) => {
    this.requestedPeekWindows[username] = true;
    this.messagingService.emit(GET_PEEK_STREAMING_INFO, username.toLowerCase());
  };

  @action resetPeekStreamData = () => {
    this.openedPeekWindows = [];
    this.requestedPeekWindows = {};
  };

  @action closePeekWindow = (performerName) => {
    this.openedPeekWindows = this.openedPeekWindows.filter(
      (peek) =>
        peek.performerName?.toLowerCase() !== performerName?.toLowerCase()
    );
  };

  @action _handlePeekStreamingError = ({ performerName }) => {
    delete this.requestedPeekWindows[performerName];
  };

  @action _handlePeekStreamingInfo = (peekStreamingInfo) => {
    this.peekStreamingInfo = { ...peekStreamingInfo };
    delete this.requestedPeekWindows[peekStreamingInfo.performerName];

    if (this.openedPeekWindows.length < 5) {
      this.openedPeekWindows = [...this.openedPeekWindows, peekStreamingInfo];
    } else {
      const filteredPeeks = this.openedPeekWindows.filter((_, i) => i !== 0);
      this.openedPeekWindows = [peekStreamingInfo, ...filteredPeeks];
    }
  };

  @action setUserType = (type) => {
    this.userType = type;
  };
}

export default new PeekStore();
